import * as types from './actionTypes';
import {apiRequest, apiPost, apiDelete} from '../utils/request';
import {toastr} from 'react-redux-toastr';

export function loadRegionsSuccess(regions){
  return {type: types.LOAD_REGIONS_SUCCESS, regions};
}

export function createRegionSuccess(region){
  return {type: types.CREATE_REGION_SUCCESS, region};
}

export function updateRegionSuccess(region){
  return {type: types.UPDATE_REGION_SUCCESS, region};
}

export function deleteRegionSuccess(region){
  return {type: types.DELETE_REGION_SUCCESS, region};
}

export function loadRegions() {
  return function (dispatch) {
    dispatch(loadRegionsSuccess({loaded: false, items: []}));
    return apiRequest(`/api/regions`)
      .then(x => {
        if (x.error || x.data.Message) {
          toastr.error(`Error while fetching regions, error: ${x.error ? x.error : x.data.Message}`);
          dispatch(loadRegionsSuccess({loaded: true, items: []}));
        } else {
          dispatch(loadRegionsSuccess({loaded: true, items: Array.from(x.data)}));
        }
      });
  };
}

export function createRegion(region) {
  return function (dispatch) {
    toastr.success('Creating region...');
    return apiPost(`/api/regions`, region)
      .then(x => {
        if (x.error || x.data.Message) {
          toastr.error(`Error while creating region, error: ${x.error ? x.error : x.data.Message}`);
        } else {
          dispatch(createRegionSuccess(x.data));
        }
      });
  };
}

export function saveRegionState(region) {
  return function (dispatch) {
    toastr.success('Updating region state...');
    return apiPost(`/api/regions/${region.id}/isactive`, !region.isInactive)
      .then(x => {
        if (x.error || x.data.Message) {
          toastr.error(`Error while creating region, error: ${x.error ? x.error : x.data.Message}`);
        } else {
          dispatch(updateRegionSuccess(region));
        }
      });
  };
}

export function deleteRegion(region) {
  return function (dispatch) {
    toastr.success('Deleting region...');
    return apiDelete(`/api/regions/${region.id}`)
      .then(x => {
        if (x.error || x.data.Message) {
          toastr.error(`Error while creating region, error: ${x.error ? x.error : x.data.Message}`);
        } else {
          dispatch(deleteRegionSuccess(region));
        }
      });
  };
}
